import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, AlertForm, AlertRedirect, MascaraCNPJ } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtVoltar,
  BtFiltroMesAtivo,
  BtFiltroMes,
  ItemListaBusca,
  BgModal,
  ModalEvento,
  TextoDescPesquisa,
  CampoFormCadastro,
  BtFiltrar,
  ListaFiltro,
  ItemListaAtendimentos,
  SolicitanteCliente,
  TipoAtendimento,
  BtFecharAtendimento,
  RespostaForm,
  BtVerRelatorioCompleto,
  BtNovoAtendimento
} from './Estilos'

import IcoBusca from './Images/ico_search_branco.png'
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function AcademiaFormularioListaRequisicoes(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(true);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ IdUser, setIdUser ] = useState(localStorage.getItem("id_tb_user"));
  const [ CPFUser, setCPFUser ] = useState(localStorage.getItem("c_cpf"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Academia - Requisições de Atendimento - Vendedor")
    }
    setTimeout(() => {
      console.log(ListaStatus);
    }, 1000);
  }, []);

  const [ ListaRequisicoes, setListaRequisicoes ] = useState([]);
  const [ ListaStatus, setListaStatus ] = useState([]);

  useEffect(() => {    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };    
    fetch(`${URLBunge}/api/Requisicoes/ListaStatus`, requestOptions)
      .then(response => response.json())
      .then(result => {

        console.log(result.listaStatus);
        ListarRequisicoes(result.listaStatus[0].idStatus);

        for(let i = 0; i < result.listaStatus.length; i = i + 1 ) {

          if(result.listaStatus[i].descricao == "Encaminhada p/ Coordenador") {
            setListaStatus(ListaStatus => [...ListaStatus, {
              value: result.listaStatus[i].idStatus,
              label: "Encaminhada para o Coordenador"
            }])
          } else if(result.listaStatus[i].descricao == "Encaminhada p/ Técnico") {
            setListaStatus(ListaStatus => [...ListaStatus, {
              value: result.listaStatus[i].idStatus,
              label: "Encaminhada para o Técnico"
            }])
          } else {
            setListaStatus(ListaStatus => [...ListaStatus, {
              value: result.listaStatus[i].idStatus,
              label: result.listaStatus[i].descricao
            }])
          }

        }
      })
      .catch(error => console.log('error', error));
  },[]);

  function ListarRequisicoes(item) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };    
    fetch(`${URLBunge}/api/Requisicoes/ListarRequisicoes/`+item, requestOptions)
      .then(response => response.json())      
      .then(result => {
        setListaRequisicoes(result.listaRequisicoes);
        console.log(result.listaRequisicoes);
        setLoading(false);
      })
      .catch(error => console.log('error', error));
  }

  const TipoSelecionadoInput = useRef();
  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  const [TipoSelecionado2, setTipoSelecionado2] = useState(0);
  function MudaLista(Tipo) {
      setTipoSelecionado2(Tipo)
      if(Tipo === 0) { LogAcesso(Token, "Academia - Requisições de Atendimento - ABERTOS") }
      if(Tipo === 1) { LogAcesso(Token, "Academia - Requisições de Atendimento - EM ANDAMENTO") }
      if(Tipo === 2) { LogAcesso(Token, "Academia - Requisições de Atendimento - FINALIZADOS") }
  }

  function MudaFiltro(){
    setListaRequisicoes([]);
    if(TipoSelecionado === 0){
      MudaLista(1)
      ListarRequisicoes(1)
    } else {
      MudaLista(TipoSelecionado)
      ListarRequisicoes(TipoSelecionado)
    }
    setLoading(true);
  }

  function FinalizarRequisicao(idRequisicao) {
    history.push({
      pathname: '/AcademiaFinalizarRequisicao',
      state: {
        idRequisicao: idRequisicao
      }
    })
    setTimeout(() => { setListaRequisicoes([]) }, 300);
  }

  const renderListaRequisicoes = ( item, index ) => {
    return <>
    <ItemListaAtendimentos key={index}>
          
          <SolicitanteCliente> Solicitante: <div>{item.solicitante}</div> </SolicitanteCliente>
          <SolicitanteCliente> Cliente: <div>{item.cliente}</div> </SolicitanteCliente>
          <TipoAtendimento> Tipo de atendimento: <div>{item.tipoAtendimento}</div> </TipoAtendimento>
          
          {
            TipoSelecionado2 == 3 ?
              item.statusPesquisaFinal === false ?
                <BtFecharAtendimento onClick={()=>FinalizarRequisicao(item.idRequisicao)}>FECHAR ATENDIMENTO</BtFecharAtendimento>
              :
              <>
                <RespostaForm>
                  <span>
                    Efetuou a venda?
                    <div>{item.efetuouVendas === true ? 'SIM' : 'NÃO'}</div>
                  </span>
                  
                  {item.efetuouVendas === false ?
                    <span>
                      Observação:
                      <div>{item.motivo}</div>
                    </span>
                    : null
                  }
                </RespostaForm>
              </>
            :null
          }
    </ItemListaAtendimentos>
    </>
  };

  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>


            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Lista de Atendimentos</TitNoticias>
                    <Clear />

                    <BtVoltar onClick={()=>history.push({ pathname: '/AcademiaBunge', state: { } })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                      <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                    </BtVoltar>
                    <Clear />

                    <br/>
                    <TextoDescPesquisa>Lista de requisições de atendimento:</TextoDescPesquisa>
                    <Clear />

                    <BtNovoAtendimento onClick={()=>history.push({ pathname: '/AcademiaFormularioAtendimento', state: { } })}><div>NOVO ATENDIMENTO</div></BtNovoAtendimento>
                    <Clear />

                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <ListaFiltro>
                        <select name={"c_estado"} id={"c_estado"} ref={register} onChange={(event) => setTipoSelecionado(event.target.value)}>
                          {/* <option value={0} disabled selected>Selecione</option> */}
                          {
                            ListaStatus.map((item, index) => {
                              return <> <option value={item.value}>{item.label}</option> </>
                            })
                          }
                        </select>
                      </ListaFiltro>

                      <BtFiltrar onClick={()=>MudaFiltro()}>Filtrar</BtFiltrar>
                    </div>

                    <Clear />
                    <br/>


                    <div style={{flex:1}}>
                      { ListaRequisicoes.length == 0 ?
                        <div>Carregando...</div>
                      :
                        ListaRequisicoes.map((item, key) => {
                          return renderListaRequisicoes(item, key)
                        })
                      }
                    </div>







                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default AcademiaFormularioListaRequisicoes;
